export default {
  "en": {
    "dashboard": {
      "greetings": "Hello {first_name}",
      "titles": {
        "activityFeed": "Activity Feed",
        "assignedTasks": "My Tasks for",
        "newsFeed": "News Feed",
        "ongoingTickets": "Ongoing",
        "openTickets": "Open",
        "tickets": "Conversations",
        "totalTickets": "All",
        "unreadTickets": "Unread",
        "yourAssignedTickets": "Your assigned conversations"
      }
    }
  }
}